import { PastelTheme } from "../.internal/themes/PastelTheme";
export default PastelTheme;
